import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import InviteClaim from "@/pages/InviteClaim";
import ProfileSetup from "@/pages/ProfileSetup";
import AppShell from "@/pages/AppShell";
import Loading from "@/pages/Loading";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.profile_complete) return <Navigate to="/setup" replace />;
  return children;
}

function SetupGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.profile_complete) return <Navigate to="/" replace />;
  return children;
}

function LoginGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "HorseTips4fun";
    const t = setInterval(() => {
      if (document.title !== "HorseTips4fun") document.title = "HorseTips4fun";
    }, 500);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/login" element={<LoginGate><Login /></LoginGate>} />
            <Route path="/invite/:token" element={<InviteClaim />} />
            <Route path="/setup" element={<SetupGate><ProfileSetup /></SetupGate>} />
            <Route path="/" element={<Protected><AppShell /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
